import React from 'react';
import { FullPageError, FullPageErrorDescription, FullPageErrorTitle, Link, TextInline, } from '@cko/primitives';
export const ErrorPage = () => {
    //@ts-ignore
    const datadogRumSessionId = window?.DD_RUM?.getInternalContext()?.session_id;
    return (React.createElement(FullPageError, null,
        React.createElement(FullPageErrorTitle, null, "We were unable to load this page"),
        datadogRumSessionId && (React.createElement(React.Fragment, null,
            React.createElement(FullPageErrorDescription, null,
                "Create a",
                React.createElement(Link, { href: "https://dashboard.checkout.com/support", variant: "inline" }, "support ticket"),
                "and share the following ID so we can help fix this issue:"),
            React.createElement(FullPageErrorDescription, null,
                React.createElement(TextInline, { color: "var(--base-text-secondary)", font: "var(--body-xs-emphasis)" }, datadogRumSessionId))))));
};
